export default __webpack_public_path__ + "static/media/bjsh-logo-large.cf17ef96.jpg";